import { render } from "./zzedit.vue?vue&type=template&id=42b76478&scoped=true"
import script from "./zzedit.vue?vue&type=script&lang=js"
export * from "./zzedit.vue?vue&type=script&lang=js"

import "./zzedit.vue?vue&type=style&index=0&id=42b76478&lang=scss&scoped=true"
import "./zzedit.vue?vue&type=style&index=1&id=42b76478&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b76478"]])

export default __exports__